(() => {
  // eslint-disable-next-line no-new, no-undef
  new Swiper(".js-announcement-bar", {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    autoplay: {
      delay: 4000,
    },
    loop: true,
    speed: 1000,
  });
})();
